export const HOOKS = {
	BEFORE_SUBMIT: 'allcoach.checkout.beforeSubmit',
	VALIDATION: 'allcoach.checkout.validation',
	VALIDATION_FAILED: 'allcoach.checkout.validationFailed',
	PAYLOAD: 'allcoach.checkout.payload',
	RESPONSE: 'allcoach.checkout.response',
	SUCCESS: 'allcoach.checkout.success',
	ERROR: 'allcoach.checkout.error',
	FINALLY: 'allcoach.checkout.finally',
} as const;
